import * as React from "react";
const IconServer5 = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M59.2 45.8 53.5 44q-.3-.15-.6 0l-5.8 1.9c-.4.1-.7.5-.7 1v4c0 1.8.1 3 .4 3.9.7 2.7 2.7 4.1 5.9 5.7.1.1.3.1.4.1s.3 0 .4-.1c5.5-2.6 6.3-4.5 6.3-10v-3.7c.1-.4-.2-.8-.6-1m-1.3 4.7c0 4.7-.4 5.9-4.7 8-2.9-1.4-4-2.5-4.4-4.2-.2-.8-.3-1.8-.3-3.4v-3.3l4.8-1.6 4.7 1.6v2.9z" />
    <path d="M62 23.9V10.8c0-2.8-2.2-5-5-5H7c-2.8 0-5 2.2-5 5V24c0 1.6.8 3.1 2 4-1.2.9-2 2.4-2 4v13.2c0 2.8 2.2 5 5 5h35.3c.6 0 1-.4 1-1s-.4-1-1-1H7c-1.7 0-3-1.3-3-3V31.9c0-1.7 1.3-3 3-3h50c1.7 0 3 1.3 3 3v9.6c0 .6.4 1 1 1s1-.4 1-1v-9.6c0-1.6-.8-3.1-2-4 1.2-.9 2-2.3 2-4m-2 0c0 1.7-1.3 3-3 3H7c-1.7 0-3-1.3-3-3V10.8c0-1.7 1.3-3 3-3h50c1.7 0 3 1.3 3 3z" />
    <path d="M15.6 16.1c-.6 0-1 .4-1 1v.2c0 .6.4 1 1 1s1-.4 1-1v-.2c0-.5-.5-1-1-1M50.8 16.2H44c-.6 0-1 .4-1 1s.4 1 1 1h6.7c.6 0 1-.4 1-1s-.4-1-.9-1M14.6 38.3v.2c0 .6.4 1 1 1s1-.4 1-1v-.2c0-.6-.4-1-1-1s-1 .4-1 1M51.8 38.3c0-.6-.4-1-1-1H44c-.6 0-1 .4-1 1s.4 1 1 1h6.7c.6 0 1.1-.5 1.1-1" />
  </svg>
);
export default IconServer5;
